var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueEditor',{attrs:{"value":_vm.value,"useCustomImageHandler":""},on:{"input":_vm.handleInput,"image-added":_vm.handleImageAdded,"image-removed":_vm.handleImageRemoved}})}
var staticRenderFns = []

export { render, staticRenderFns }